// extracted by mini-css-extract-plugin
var _1 = "FlyoverMapStats-module__animStat___nT0FR";
var _2 = "FlyoverMapStats-module__animStatsContainer___Bi1fj";
var _3 = "FlyoverMapStats-module__stat___CP_vn";
var _4 = "FlyoverMapStats-module__statTitle___V1nTK";
export { _1 as "animStat", _2 as "animStatsContainer", _3 as "stat", _4 as "statTitle" }
